import React from 'react';
import cn from 'classnames';
import Media from 'react-media';
import { Divider } from '@lightspeed/flame/Divider';
import Group from '@lightspeed/cirrus-group';
import { IconVerified } from '@lightspeed/flame/Icon/Verified';
import Text from '@lightspeed/cirrus-text';
import { breakpoints } from 'pages/utils/media';

const Tabs = ({ tabs = [], currentStep, setStep }) => (
  <Media query={{ minWidth: breakpoints.md }}>
    {matches => (
      <div className={!matches ? 'cr-position-sticky' : ''} style={{ top: 0, zIndex: 1 }}>
        <div
          className="cr-flex cr-bg-snow-200 cr-ph-1"
          style={{ borderTopLeftRadius: '6px', borderTopRightRadius: '6px' }}
        >
          {tabs.map(({ name }, index) => {
            const isActive = currentStep === index + 1;
            const isValid = currentStep > index + 1;
            const onClick = isValid ? () => setStep(index + 1) : null;

            return (
              // eslint-disable-next-line
              <div role="button" data-test={`step-${index + 1}-title`} onClick={onClick} key={name}>
                {isValid ? (
                  <Group className="cr-mh-3 cr-pv-2 cr-cursor-pointer">
                    <IconVerified baseColor1="green" size="1.5rem" />
                    <Text bold>{name}</Text>
                  </Group>
                ) : (
                  <Group className={`cr-mh-3 cr-pv-2 ${isActive ? 'tab--active' : ''}`}>
                    <div
                      className={cn('cr-radius-circle cr-text-center tab-circle', {
                        'cr-bg-blue': isActive,
                        'cr-bg-gray-200': !isActive,
                      })}
                    >
                      <Text color="snow" style={{ lineHeight: '24px' }}>
                        {index + 1}
                      </Text>
                    </div>
                    <Text bold>{name}</Text>
                  </Group>
                )}
              </div>
            );
          })}
        </div>
        <Divider />
      </div>
    )}
  </Media>
);

export default Tabs;
